import gql from 'graphql-tag';
import { PERMISSION_FRAGMENT, ROLE_FRAGMENT } from './fragment';
import {USER_INFO_FRAGMENT} from "../user/fragment";

export const SET_ROLES = gql`
  mutation SetRoles($inputs: [SetRolesInput]) {
    setRoles(inputs: $inputs) {
      ...RoleInfo
      permissions {
        ...PermissionInfo
      }
    }
  }
  ${ROLE_FRAGMENT}
  ${PERMISSION_FRAGMENT}
`;

export const SET_USER_PERMISSIONS = gql`
  mutation SetUserPermissions($input: SetUserPermissionsInput) {
    setUserPermissions(input: $input) {
      ...UserInfo
    }
  }
  ${USER_INFO_FRAGMENT}
`;
